var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "ratio ratio-16x9" }, [
      _c("iframe", {
        ref: "video",
        attrs: {
          src: `https://www.youtube.com/embed/${_vm.youtube_id}`,
          frameborder: "0",
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center align-items-center w-100 h-100",
        staticStyle: { "z-index": "-1" },
      },
      [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }